import { Component, Input, OnInit } from '@angular/core';
import { MatTooltipModule, MatTooltip } from '@angular/material/tooltip';
import { tooltipConstants } from '../../../../shared/constants';

@Component({
    selector: 'information-message',
    templateUrl: './information-message-tooltip.component.html',
    styleUrls: ['./information-message-tooltip.component.scss'],
    standalone: true,
    imports: [MatTooltip]
})
export class InformationMessageTooltipComponent implements OnInit, MatTooltipModule {
  @Input('tooltip') infoMessage: string;


  ngOnInit(): void {
    this.infoMessage = tooltipConstants.infoMessage;
  }

}
